import {Exclude, Type} from 'class-transformer';

import {AbstractSliderQuestionType} from './abstract-slider-question-type';
import {AnswerOption} from './answer-option';
import {KeyPoint} from './keypoint';
import {QuestionType} from './question-type';
import {SliderQuestionType} from './slider-question-type';

export class MultiSliderQuestionType implements QuestionType {

  public name: string = 'multislider';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Multi-Slider';
  @Exclude({toPlainOnly: true})
  public icon: string = 'sliders';
  @Type(() => SliderQuestionType)
  // class-transformer doesn't work with generics
  // tslint:disable-next-line:array-type
  public sliders: AbstractSliderQuestionType[] = [];

  public getAnswerOptions(): Array<AnswerOption> {
    return [{
      label: '',
      value: '',
    }];
  }

  public addSlider(type: string): AbstractSliderQuestionType {
    let slider: AbstractSliderQuestionType;

    if (type === 'slider') {
      slider = new SliderQuestionType(true);
    }

    this.sliders.push(slider);

    return slider;
  }

  public removeSlider(index: number): void {
    this.sliders.splice(index, 1);
  }

  public addKeyPoint(sliderIndex: number): KeyPoint {
    return this.sliders[sliderIndex].addKeyPoint();
  }

  public deleteKeyPoint(sliderIndex: number, keyPointIndex: number): void {
    this.sliders[sliderIndex].deleteKeyPoint(keyPointIndex);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/multi-slider-question-type.ts